<div class="">
  <div class="">
    <p-panel header="Supplier Feedback">
      <div class="ui-g" style="height: 100%; padding-left: 0">
        <p-progressBar
          *ngIf="isBusy"
          mode="indeterminate"
          class="ui-progressbar-indeterminate"
        ></p-progressBar>
        <div class="ui-g-12 datatable-panel" style="height: 100%; margin-bottom: 0px">
          <p-table
            #dt
            [value]="supplierFeedbackPage.items"
            [lazy]="true"
            [rows]="10"
            [responsive]="true"
            rowHover="true"
            [totalRecords]="supplierFeedbackPage.total"
            (onLazyLoad)="onSupplierFeedbackGridLazyLoad($event)"
            [hidden]="!isLoadedSupplierFeedback"
            [(selection)]="selectedSupplierFeedback"
            selectionMode="single"
          >
            <ng-template pTemplate="header">
              <tr>
                <th pSortableColumn="orderNumber">Order No</th>
                <th pSortableColumn="taskKey">Task</th>
                <th pSortableColumn="customerName">Customer</th>
                <th pSortableColumn="supplierName">Feedback</th>
                <th pSortableColumn="createdOn">Created</th>
                <th pSortableColumn="lastUpdated">Last Updated</th>
                <th>Status</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-item>
              <tr [pSelectableRow]="item">
                <td>{{ item.orderNumber }}</td>
                <td>{{ item.taskKey }}</td>
                <td>{{ item.customerName }}</td>
                <td>{{ item.supplierName }}</td>
                <td>{{ item.supplierFeedbackType.description }}</td>
                <td>
                  <span>{{ item.lastUpdated | date : 'dd/MM/yyyy' }}</span>
                </td>
                <td>
                  <span
                    class="badge"
                    [class.green]="item.resolvedTimeStamp == null"
                    [class.orange]="item.resolvedTimeStamp != null"
                  >
                    {{ item.resolvedTimeStamp != null ? 'Resolved' : 'Open' }}
                  </span>
                </td>
              </tr>
            </ng-template>
          </p-table>
          <!--- DATATABLE DEPRECATED ---
                    <p-dataTabl #dt [value]="supplierFeedbackPage.items" [lazy]="true" [rows]="10"
                                 [responsive]="true" rowHover="true"
                                 [totalRecords]="supplierFeedbackPage.total"
                                 (onLazyLoad)="onSupplierFeedbackGridLazyLoad($event)"
                                 [hidden]="!isLoadedSupplierFeedback" [(selection)]="selectedSupplierFeedback"
                                 selectionMode="single">
                        <p-column field="orderNumber" header="Order No" [style]="{'width':'125px'}"
                                  [sortable]="tru"></p-column>
                        <p-column field="taskKey" header="Task" [style]="{'width':'250px'}"
                                  [sortable]="tru"></p-column>
                        <p-column field="customerName" header="Customer" [sortable]="tru"></p-column>
                        <p-column field="supplierName" header="Supplier"
                                  [sortable]="tru"></p-column>
                        <p-column field="supplierFeedbackType.description" header="Feedback"
                                  [sortable]="tru"></p-column>
                        <p-column field="createdOn" header="Created" [style]="{'width':'110px'}"
                                  [sortable]="tru">
                            <ng-template let-col let-feedback="rowData" pTemplate="body">
                                <span>{{ feedback[col.field] | date:'dd/MM/yyyy' }}</span>
                            </ng-template>
                        </p-column>
                        <p-column field="lastUpdated" header="Last Updated"
                                  [style]="{'width':'120px'}" [sortable]="tru">
                            <ng-template let-col let-feedback="rowData" pTemplate="body">
                                <span>{{ feedback[col.field] | date:'dd/MM/yyyy' }}</span>
                            </ng-template>
                        </p-column>
                        <p-column field="status" header="Status" [style]="{'width':'90px'}">
                            <ng-template let-col let-feedback="rowData" pTemplate="body">
                                <span class="badge" [class.green]="feedback.resolvedTimeStamp == null"
                                      [class.orange]="feedback.resolvedTimeStamp != null">
                                    {{ feedback.resolvedTimeStamp != null ? "Resolved" : "Open" }}
                                </span>
                            </ng-template>
                        </p-column>
                    </p-dataTable>
                    --->
          <ng-template #loading>Loading...</ng-template>
          <div style="width: 100%; height: 40px; margin-top: 20px">
            <new-supplier-feedback
              #newFeedbackControl
              (feedbackCreated)="onFeedbackCreated()"
            ></new-supplier-feedback>
            <button
              type="button"
              pButton
              icon="fa ui-icon-edit"
              label="Edit"
              class="ui-button btn-to-right"
              (click)="editSupplierFeedback(selectedSupplierFeedback.id)"
              [disabled]="
                !selectedSupplierFeedback || selectedSupplierFeedback.resolvedTimeStamp != null
              "
            ></button>
            <button
              type="button"
              pButton
              icon="fa ui-icon-edit"
              label="Go to Details"
              class="ui-button btn-to-right"
              (click)="openSupplierFeedback(selectedSupplierFeedback.id)"
              [disabled]="!selectedSupplierFeedback"
            ></button>
            <button
              type="button"
              pButton
              icon="fa ui-icon-add"
              label="Add"
              class="ui-button green-btn btn-to-right"
              (click)="addSupplierFeedback()"
            ></button>
          </div>
        </div>
      </div>
    </p-panel>
  </div>
</div>
